import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom';


const WhiteTooltip = ({ show, anchorRef, children }) => {
  const tooltipRef = useRef(null);
  const [style, setStyle] = useState({});
  const [position, setPosition] = useState("left"); // left | right

  useEffect(() => {
    if (!show || !anchorRef?.current || !tooltipRef.current) return;

    const anchor = anchorRef.current.getBoundingClientRect();
    const tooltip = tooltipRef.current.getBoundingClientRect();
    const gap = 8;

    const spaceLeft = anchor.left;
    const spaceRight = window.innerWidth - anchor.right;

    const isLeft = spaceLeft > tooltip.width + gap;

    setPosition(isLeft ? "left" : "right");

    setStyle({
      top: anchor.top + anchor.height / 2 - tooltip.height / 2,
      left: isLeft
        ? anchor.left - tooltip.width - gap
        : anchor.right + gap,
    });
  }, [show, anchorRef]);

  if (!show) return null;

  return createPortal(
    <div
      ref={tooltipRef}
      className={`white-tooltip ${position}`}
      style={style}
    >
      {children}
    </div>,
    document.body
  );
};

export default WhiteTooltip